import { render, staticRenderFns } from "./EditReceiveAddress.vue?vue&type=template&id=41695426&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./EditReceiveAddress.vue?vue&type=script&lang=js&"
export * from "./EditReceiveAddress.vue?vue&type=script&lang=js&"
import style0 from "./EditReceiveAddress.vue?vue&type=style&index=0&id=41695426&lang=stylus&scoped=true&"
import style1 from "./EditReceiveAddress.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41695426",
  null
  
)

export default component.exports